// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"2ab40e131702e525","777":"efc26cacdf4b713d"}[chunkId] + ".js";
};